/**
 * Google Tag Manager configuration
 */

// This should be replaced with your actual GTM ID
export const GTM_ID = 'GTM-MDDLMNML';

// Initialize data layer array
export function initDataLayer() {
  return `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
  `;
}

// Generate GTM script tag
export function generateGTMScript(id: string) {
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');
  `;
}

// Generate GTM noscript tag content
export function generateGTMNoScript(id: string) {
  return `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
}

// Push event to data layer
export function pushEvent(event: Record<string, unknown>) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(event);
  }
}

// Declare dataLayer for TypeScript
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}